import clsx from 'clsx';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { storeLocale } from '@/root/constants';
import { Breadcrumbs } from 'components/breadcrumbs/Breadcrumbs';
import { ProductIncreasinglySection } from 'components/increasinglySection/ProductIncreasinglySection';
import { ProductColorSelector } from 'components/productColorSelector/ProductColorSelector';
import { ProductContentTabs } from 'components/productContentTabs/ProductContentTabs';
import { ProductProvider } from 'components/productContext/ProductProvider';
import { ProductForm } from 'components/productForm/ProductForm';
import { ProductGallery } from 'components/productGallery/ProductGallery';
import ProductReviews from 'components/productReviews/ProductReviews';
import { ProductSections } from 'components/productSections/ProductSections';
import ProductStructuredData from 'components/productStructuredData/ProductStructuredData';
import { RecommendedEssentials } from 'components/recommendedEssentials/RecommendedEssentials';
import { TryShadeSectionConnected } from 'components/tryShadeSectionConnected/TryShadeSectionConnected';
import styles from './products.module.scss';

export const ProductsRoute = () => {
  const { locale: routerLocale } = useRouter();
  const locale = storeLocale(routerLocale);
  return (
    <ProductProvider>
      {locale === 'en-GB' && (
        <Script
          async
          data-environment="production"
          src="https://js.klarna.com/web-sdk/v1/klarna.js"
          data-client-id="eab46669-ae4a-5fef-8bd2-532ffe4fe5b6"
        />
      )}
      <ProductStructuredData />
      <Breadcrumbs type={'product'} />
      <div className={[styles.productRoute, 'component-section'].join(' ')}>
        <div
          className={clsx(
            styles.productRoute__grid,
            styles.productRoute__galleryGrid
          )}
        >
          <div
            className={[styles.productRoute__gallery, 'col xs4 m8 l8'].join(
              ' '
            )}
          >
            <ProductGallery />
          </div>
          <div
            className={[styles.productRoute__productCard, 'col xs4 m4 l4'].join(
              ' '
            )}
          >
            <ProductForm colorSelector={<ProductColorSelector />} />
          </div>
        </div>

        <div className={styles.productRoute__grid}>
          <div className={styles.productRoute__contentTabs}>
            <ProductContentTabs />
          </div>

          <RecommendedEssentials />
        </div>
      </div>

      <ProductIncreasinglySection />

      <TryShadeSectionConnected />

      <ProductSections />

      <ProductReviews />
    </ProductProvider>
  );
};
